import { Box, BoxProps } from '@mui/material';
import React from 'react';

export const FormFieldWrapper: React.FC<BoxProps> = (props) => (
  <Box display="flex" justifyContent="center" mt={2} {...props} />
);

export const FormSubmitWrapper: React.FC<BoxProps> = (props) => (
  <Box display="flex" justifyContent="center" mb={3} mt={5} {...props} />
);

export const FormWrapper: React.FC<BoxProps> = (props) => <Box m="auto" width="70%" {...props} />;
